module.exports = __webpack_public_path__ + "static/media/loading-animate.dda4af80.gif";


//////////////////
// WEBPACK FOOTER
// ./node_modules/loyal-design-system/assets/images/loading-animate.gif
// module id = 445
// module chunks = 18